"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _types = require('web/screens/Signup/types');


// Pre-auth wizard draft so a refresh or same-machine reopen doesn't wipe the
// user's typed answers. Deliberately excludes the password and all MFA state:
// those are redone fresh on every resume, so the draft only ever holds what an
// invite email already reveals. The TTL bounds exposure on shared clinic
// machines — an expired or foreign-token draft is cleared on read.
const STORAGE_KEY = 'bt_signup_draft'

 const SIGNUP_DRAFT_TTL_MS = 60 * 60 * 1000; exports.SIGNUP_DRAFT_TTL_MS = SIGNUP_DRAFT_TTL_MS














const read = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const draft = JSON.parse(raw) 
    if (typeof _optionalChain([draft, 'optionalAccess', _ => _.token]) !== 'string' || typeof _optionalChain([draft, 'optionalAccess', _2 => _2.savedAt]) !== 'number') return null
    return draft
  } catch (e) {
    return null
  }
}

 const clearSignupDraft = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // Storage unavailable (private mode, disabled) — drafts are best-effort.
  }
}; exports.clearSignupDraft = clearSignupDraft

 const loadSignupDraft = (token) => {
  const draft = read()
  if (!draft) return null
  if (draft.token !== token || Date.now() - draft.savedAt > exports.SIGNUP_DRAFT_TTL_MS) {
    exports.clearSignupDraft.call(void 0, )
    return null
  }
  return draft
}; exports.loadSignupDraft = loadSignupDraft

 const saveSignupDraft = (
  token,
  patch,
) => {
  const prior = exports.loadSignupDraft.call(void 0, token)
  const draft = {
    token,
    savedAt: Date.now(),
    personalInfo: _nullishCoalesce(_optionalChain([prior, 'optionalAccess', _3 => _3.personalInfo]), () => ( null)),
    requestedOrgRels: _nullishCoalesce(_optionalChain([prior, 'optionalAccess', _4 => _4.requestedOrgRels]), () => ( [])),
    surveyAnswers: _nullishCoalesce(_optionalChain([prior, 'optionalAccess', _5 => _5.surveyAnswers]), () => ( null)),
    selectedTier: _nullishCoalesce(_optionalChain([prior, 'optionalAccess', _6 => _6.selectedTier]), () => ( null)),
    maxStep: _nullishCoalesce(_optionalChain([prior, 'optionalAccess', _7 => _7.maxStep]), () => ( null)),
    ...patch,
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
  } catch (e) {
    // Storage unavailable — drafts are best-effort.
  }
}; exports.saveSignupDraft = saveSignupDraft

// Where a refreshed wizard resumes. The draft never holds the password or
// any MFA proof, so the earliest incomplete step bounds the landing spot:
// - no personal info yet → start over at PERSONAL_INFO;
// - a phone on file → PERSONAL_INFO too, because re-submitting it is what
//   re-issues the SMS challenge the submission will need;
// - otherwise → PASSWORD (re-entered fresh every resume), with the saved
//   high-water mark keeping the already-answered steps forward-clickable,
//   capped at PRODUCT_INTEREST so the survey re-submit rebuilds the parked
//   state and the legal step is re-accepted on the way through.
 const resumeStepsFromDraft = (
  draft,
) => {
  const start = { step: _types.SetupSteps.PERSONAL_INFO, maxStep: _types.SetupSteps.PERSONAL_INFO }
  if (!_optionalChain([draft, 'optionalAccess', _8 => _8.personalInfo])) return start
  if (draft.personalInfo.phone) return start
  const saved = Math.min(_nullishCoalesce(draft.maxStep, () => ( _types.SetupSteps.PERSONAL_INFO)), _types.SetupSteps.PRODUCT_INTEREST)
  if (saved <= _types.SetupSteps.PERSONAL_INFO) return start
  return { step: _types.SetupSteps.PASSWORD, maxStep: Math.max(saved, _types.SetupSteps.PASSWORD) }
}; exports.resumeStepsFromDraft = resumeStepsFromDraft
